"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _math = require("@staccx/math");

var _Label = _interopRequireDefault(require("../Label/Label"));

var _Caret = _interopRequireDefault(require("../../Icons/Caret"));

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

var _ThemeComponent = _interopRequireDefault(require("../../Theme/ThemeComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var tProps = {
  iconComponent: {
    name: "COMPONENT_SELECT_SIMPLE_ICON",
    description: "Icon component",
    type: _themeContants.themePropTypes.component
  },
  wrapper: {
    name: "SELECT_SIMPLE_WRAPPER",
    description: "Wrapper style",
    type: _themeContants.themePropTypes.style
  },
  icon: {
    name: "SELECT_SIMPLE_ICON",
    description: "Icon style",
    type: _themeContants.themePropTypes.style
  },
  select: {
    name: "SELECT_SIMPLE_SELECT",
    description: "Icon style",
    type: _themeContants.themePropTypes.style
  }
};

var IconComponent = function IconComponent(_ref) {
  var props = _extends({}, _ref);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: tProps.iconComponent,
    fallback: _Caret["default"]
  }, props));
};

var SelectSimple = function SelectSimple(_ref2) {
  var children = _ref2.children,
      label = _ref2.label,
      placeholder = _ref2.placeholder,
      className = _ref2.className,
      id = _ref2.id,
      variant = _ref2.variant,
      rest = _objectWithoutProperties(_ref2, ["children", "label", "placeholder", "className", "id", "variant"]);

  return _react["default"].createElement(SelectWrapper, {
    className: className,
    variant: variant
  }, label && _react["default"].createElement(_Label["default"], {
    htmlFor: id,
    variant: variant
  }, label), _react["default"].createElement(Select, _extends({
    id: id,
    defaultValue: placeholder || "",
    variant: variant
  }, rest), placeholder && _react["default"].createElement("option", {
    disabled: true,
    value: placeholder
  }, placeholder), children), _react["default"].createElement(SelectIcon, null));
};

var SelectWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SelectSimple__SelectWrapper",
  componentId: "sc-6fvsco-0"
})(["display:block;margin-bottom:0;position:relative;", ";"], (0, _theming.applyVariants)(tProps.wrapper));

var SelectIcon = (0, _styledComponents["default"])(IconComponent).withConfig({
  displayName: "SelectSimple__SelectIcon",
  componentId: "sc-6fvsco-1"
})(["position:absolute;right:", ";bottom:", ";width:12px;fill:", ";transform:translateY(50%);transition:fill 0.2s ease;pointer-events:none;", ";"], _theming.spacing.small, function (p) {
  var value = _theming.targetSize.normal()(p);

  return (0, _math.multiplyPixelValue)(value, 0.5);
}, _theming.color.gray, (0, _theming.applyVariants)(tProps.icon));

var Select = _styledComponents["default"].select.withConfig({
  displayName: "SelectSimple__Select",
  componentId: "sc-6fvsco-2"
})(["width:100%;min-height:", ";font-size:", ";padding:10px ", " 10px ", ";box-shadow:none;border-radius:", ";line-height:1.4;border:1px solid ", ";background-color:", ";-webkit-appearance:none;appearance:none;cursor:pointer;&:focus,&:hover{color:", ";border-color:", ";outline:none;~ ", "{fill:", ";}}", ";"], _theming.targetSize.normal, _theming.font.input, _theming.spacing.medium, _theming.spacing.small, _theming.borderRadius, _theming.color.line, _theming.color.white, _theming.color.primary, _theming.color.line, SelectIcon, _theming.color.primary, (0, _theming.applyVariants)(tProps.select));

SelectSimple.defaultProps = {
  className: "",
  placeholder: "",
  label: null
};
SelectSimple.propTypes = {
  label: _propTypes["default"].string,
  children: _themeContants.commonPropTypes.children.isRequired,
  placeholder: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string
};
SelectSimple.themeProps = tProps;
var _default = SelectSimple;
exports["default"] = _default;